import { AfterContentChecked, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HelperService } from 'src/app/public/helper.service';
import { LocationService } from 'src/app/public/location.service';
import { SelectedStoreState } from 'src/app/public/store/+state/stores.reducer';
import { getCurrentCartStatus, getSelectedStore } from 'src/app/public/store/+state/stores.selectors';
import { OrderItem } from 'src/app/stores/stores';

@Component({
  selector: 'app-view-order-button',
  templateUrl: './view-order-button.component.html',
  styleUrls: ['./view-order-button.component.scss'],
})
export class ViewOrderButtonComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  @Input() customerFooterHeight: number;
  @Input() selectedCatalog: number;
  @Input() showPayOnlineButton: boolean;
  @Input() cartItemsTotalValue: number;
  @Input() cartItems: OrderItem[] = [];
  @Input() totalQuantity: number;
  @Input() selectedStoreLocale: string;
  @Input() selectedStoreCurrency: string;
  @Input() selectedStoreCurrencySymbol: string;
  @Input() acceptTermVisible = false;
  @Input() showAlways = false;

  @Output() viewOrder = new EventEmitter<any>();
  @Output() payOnline = new EventEmitter<any>();

  unsubscribe$: Subject<void> = new Subject<void>();
  currentCartStatus: string;
  basketEnabled = false;
  isAdminOrderCaptureUpdate: boolean;
  isGoApp = false;
  elementWidth: number;
  cookieBarHeight: number = 0;

  constructor(
    private store: Store<SelectedStoreState>,
    private locationService: LocationService,
    private helper: HelperService,
    private _ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isAdminOrderCaptureUpdate = this.locationService.isAdminOrderCaptureUpdate();
    this.isGoApp = this.helper.isGoApp();

    this.store
      .pipe(select(getSelectedStore))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((selectedStore) => {
        this.basketEnabled = selectedStore?.settings?.BASKET_ENABLED;
      });

    this.store
      .pipe(select(getCurrentCartStatus))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((cartStatus) => {
        this.currentCartStatus = cartStatus;
      });
  }

  ngAfterViewInit(): void {
    this.observeResize('button-container', (width) => this.elementWidth = width);
    this.observeResize('sticky-cookie', (height) => this.cookieBarHeight = height);
  }

  ngAfterViewChecked(): void {
    const cookieBarHeight = this.helper.getCookieBarHeight();

    if (this.cookieBarHeight !== cookieBarHeight) {
      this.cookieBarHeight = cookieBarHeight;
      this._ref.detectChanges();
    }
  }

  private observeResize(elementId: string, updateFunction: (size: number) => void): void {
    const element = document.getElementById(elementId);
    if (!element) return;

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (elementId === 'button-container') {
        updateFunction(entry.contentRect.width);
      } else {
        updateFunction(entry.target.clientHeight);
      }
      this._ref.detectChanges();
    });

    observer.observe(element);
    this.unsubscribe$.subscribe(() => observer.disconnect());
  }

  onViewOrder(event) {
    this.viewOrder.emit(event);
  }

  onPayOnline() {
    this.payOnline.emit();
  }

  showStandalonePaymentButton() : boolean {
    return this.showPayOnlineButton && this.cartItemsTotalValue === 0 && this.cartItems?.length === 0;
  }

  showViewOrderWithoutValueButton() : boolean {
    return this.cartItems?.length > 0 && this.cartItemsTotalValue == 0
  }

  showViewOrderWithValueButton() : boolean {
    return this.cartItems?.length > 0 && this.cartItemsTotalValue > 0;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
